module.exports = __webpack_public_path__ + "images/heroimagecontainer7d221c249bdf2f58f3c69703dabdc6d9.png";